import {
  CasinoRoundsResponse,
  CasinoTicket,
  CasinoTicketDetail,
  CasinoTicketsResponse,
  Game,
  GamesResponse,
  GameStartResponse,
  RecommendedGamesResponse,
  SearchResponse,
} from '../data-types/casino/casinoInterfaces';
import { DEFAULT_ERROR_MESSAGE } from '../data-types/initialisation/initialisationConstants';
import { casinoRounds, casinoTickets, gamesGet, gamesSearch, gameStart } from '../socket-types/casinoSocketTypes';
import { sendCommand } from './commandsHandler';

/**
 * Gets the list of casino games corresponding to a category id
 */
export const getGames = async (category: number) => {
  const res = await sendCommand<GamesResponse>(gamesGet, { category });
  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

export const getRecommendedGames = async (userId: number, limit: number, category: number) => {
  const res = await sendCommand<RecommendedGamesResponse>('games:getrecommendedkwiffpicks', { userId, limit, category });
  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res;
  }

  throw new Error('Something went wrong');
};

/**
 * Gets the list of casino games corresponding to a category id
 */
export const startGame = async (gameId: number) => {
  const res = await sendCommand<GameStartResponse>(gameStart, { gameId, channel: 'webapp' });

  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res.data;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

/**
 * Gets the list of casino bets placed by the user
 */
export const getCasinoTickets = async (): Promise<CasinoTicket[]> => {
  const res = await sendCommand<CasinoTicketsResponse>(casinoTickets, {});
  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data && res.data.casinoTickets) {
    return res.data.casinoTickets;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

/**
 * Gets the list of casino bets placed by the user
 */
export const getTicketDetails = async (sessionId: string): Promise<CasinoTicketDetail[]> => {
  const res = await sendCommand<CasinoRoundsResponse>(casinoRounds, { sessionId });
  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data && res.data.casinoRounds) {
    return res.data.casinoRounds;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

/**
 * Returns game search results
 */
export const searchResults = async (searchValue: string): Promise<Game[]> => {
  const res = await sendCommand<SearchResponse>(gamesSearch, { category: 0, searchData: searchValue });
  if (res.error && res.error.notification && res.error.notification.userFriendlyMessage) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res.data.games;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};
